import DaData from './DaData'
import './DaData.css'

export default DaData


// WEBPACK FOOTER //
// ./src/features/OrderDetails/components/DaData/index.js